import React from 'react';
import Joi from 'joi';

import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { array, bool, func } from 'prop-types';
import { matchPhrases } from '../../../utils/utilities';
import { OTHER_DESCRIPTION } from '../../../utils/constants';

import toastService from '../../../services/toastService';


class CustomUTMInspectionItemForm extends Form {
	state = {
		data: {
			tmlLocation: '',
			description: '',
			otherDescription: '',
			nominal: '',
			comments: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema: any = {
		tmlLocation: Joi.string().required().label('Location Sr. No.'),
		description: Joi.string().min(1).required().label('Description'),
		otherDescription: Joi.string().when('description', {
			is: OTHER_DESCRIPTION,
			then: Joi.string().min(3).required().label('Other Description'),
			otherwise: Joi.string().allow('').label('Other Description'),
		}),
		nominal: Joi.alternatives().try(Joi.number().min(0), Joi.string().valid('NG')).required().label('Nominal'),
		comments: Joi.string().min(3).required().label('Comments'),
	};

	static propTypes = {
		includeSize: bool,
		options: array,
		defaultColumns: array,
		onAdd: func,
	};

	componentDidMount() {
		this.setState({ data: this.mapInitialData() });
	}

	mapInitialData = () => {
		const initialData: any = {
			tmlLocation: '',
			description: '',
			otherDescription: '',
			nominal: '',
		};

		if (this.props.includeSize) {
			initialData.size = 0;
			this.schema.size = Joi.number().min(1).required().label('Size (Inches)');
		}

		if (this.props.defaultColumns.length > 0) {
			for (const column of this.props.defaultColumns) {
				initialData[column] = '';
				this.schema[column] = Joi.alternatives().try(Joi.number().min(0), Joi.string().valid('N/A')).required().label(column);
			}
		}

		initialData.comments = '';
		return initialData;
	};

	getDescriptionLabel = () => {
		if (this.state.data.description === OTHER_DESCRIPTION) {
			return this.state.data.otherDescription;
		}

		return this.state.data.description;
	};

	doSubmit = (): void => {
		const description = this.getDescriptionLabel();
		if (matchPhrases(description, OTHER_DESCRIPTION)) return toastService.error('Description cannot be others');

		const { otherDescription, ...data } = this.state.data;
		
		this.props.onAdd({ ...data, description });
		this.setState({ data: this.mapInitialData() });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'tmlLocation',
							label: 'Location Sr. No.',
							placeholder: 'Enter Location Sr. No.',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							options: this.props.options,
							name: 'description',
							placeholder: 'Select Description',
							label: 'Description',
						})}
					</div>

					<Conditional isVisible={this.state.data.description === OTHER_DESCRIPTION}>
						<div className="col">
							{this.renderInput({
								name: 'otherDescription',
								type: 'text',
								placeholder: 'Enter Other Description',
								label: 'Other Description',
							})}
						</div>
					</Conditional>

					<Conditional isVisible={this.props.includeSize}>
						<div className="col">
							{this.renderInput({
								type: 'number',
								name: 'size',
								label: 'Size (Inches)',
								placeholder: 'e.g. Inches',
							})}
						</div>
					</Conditional>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'nominal',
							label: 'Nominal (mm)',
							placeholder: 'Enter Nominal',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					{this.props.defaultColumns.map((column: string, index: number) => (
						<React.Fragment key={index}>
							<div className="col">
								{this.renderInput({
									type: 'text',
									name: column,
									label: column,
									placeholder: `Enter '${column}' value`,
								})}
							</div>

							<Conditional isVisible={(index + 1) % 3 === 0}>
								<div className="w-100"></div>
							</Conditional>
						</React.Fragment>
					))}
				</div>

				<div className="divider my-4"></div>

				{this.renderTextArea({
					rows: '4',
					name: 'comments',
					label: 'Comments.',
					placeholder: 'Enter your comments here',
				})}

				{this.renderButton('Add Item')}
			</form>
		);
	}
}

export default CustomUTMInspectionItemForm;
